import mqtt from "mqtt";
import MultiHashMap from './MultiHashMap';


class MqttClientSingleton {

    constructor() {
        if (MqttClientSingleton.instance) {
            return MqttClientSingleton.instance;
        }

        this.client = null;
        this.subscriptions = new MultiHashMap();
        MqttClientSingleton.instance = this;
    }

    connect(url, options) {
        options['keepalive'] = 45;
        this.client = mqtt.connect(url, options);

        this.client.on('connect', () => {
            console.warn("MqttClientSingleton connected to MQTT server");
        });

        this.client.on('message', (topic, messageBuffer) => {
            let message = messageBuffer.toString();
            const callbacks = this.subscriptions.get(topic);
            callbacks.forEach(callback => {
                console.info("MqttClientSingleton", topic);
                callback(topic, message);
            });
            // if (this.subscriptions[topic]) {
            //     console.info("MqttClientSingleton", topic);
            //     let message = messageBuffer.toString();
            //     this.subscriptions[topic](topic, message);
            // }
        });

        return this.client;
    }

    getClient() {
        return this.client;
    }


    subscribeTopic(topic, callback) {
        if (!topic || typeof topic !== 'string') {
            throw new Error('Subscription key must be a non-empty string');
        }
        console.log("MqttClientSingleton subscribe", topic);
        this.client?.subscribe(topic, null, (err) => {
            if (err) {
                console.error(err);
            }
        });
        this.subscriptions.add(topic, callback);
    }


    unsubscribeTopic(topic, callback) {
        if (!topic || typeof topic !== 'string') {
            throw new Error('Unsubscription key must be a non-empty string');
        }
        // this.client?.unsubscribe(topic);
        // delete this.subscriptions[topic];
        this.subscriptions.remove(topic, callback);
        if (!this.subscriptions.hasKey(topic)) {
            this.client?.unsubscribe(topic);
        }
    }


    publish(topic, message, options) {
        this.client?.publish(topic, message, options);
    }
}

const mqttSingletonInstance = new MqttClientSingleton();
export default mqttSingletonInstance;


